export function clueMapperListResponse(json, headers) {

  let data = json.map((resource) => ({
    ...resource,
    id: resource.objectId,
    clueId: resource.objectId,
    type: 'clue',
    description: resource.name,
    url: '/clue/' + resource.objectId+'/show',
    content:resource
  }))

  return {
    data,
    total: data.length,
  };
}

export function fixUpdateClueId(json) {
  return {
    data: { ...json, id: json.objectId },
  };
}

export function fixCreateClueId(params, json) {
  return {
    data: { ...params.data, id: json.result.objectId },
  };
}

export function fixGetManyClue(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      clueId: resource.objectId,
    })),
  };
}

export function clueMapperGetOneResponse(json) {
  return {
    data: { ...json.result, id: json.result.objectId, clueId: json.result.objectId },
  };
}